import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class NotepadsService extends ApiService {
  template = "defaultTemplate";
  namespace = "notepad";
  DOMAIN = 156;
  Width = 1200;
  icon = "Application";
  action = "action";
  name = "Notepad";
  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: "Notepads" }),
      icon: PrimeIcons.LIST,
    },
    {
      key: "notepad",
      label: this.t("myEntity", { entity: "Notepads" }),
      icon: PrimeIcons.PLUS_CIRCLE,
    },

    {
      key: "listing",
      label: this.t("allEntity", { entity: "Notepads" }),
      icon: PrimeIcons.LIST,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit an Header/Footer",
      icon: PrimeIcons.PENCIL,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Header",
      icon: PrimeIcons.LIST,
    },
  ];
  columns = [
    {
      header: this.t("name"),
      icon: "Pencil",
      field: "name",
    },
    {
      header: this.t("linkedTo"),
      icon: "Link",
      field: "linked_to",
    },

    {
      header: this.t("lastModified"),
      icon: "Calendar",
      field: "last_modified",
    },
    {
      icon: "Calendar",
      field: "updated_at",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: "Bookmark",
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: "Disable",
    },
  ];

  constructor() {
    super("notepads");
  }
}
